/**
 * The properties every Kelly event carries, published by `KellyAnalyticsProvider` and read by
 * `analytics/dock-provider.tsx` and `chatbox/use-kelly-analytics.ts`. One owner, so a new surface fact is added
 * here rather than threaded through the nineteen call sites that track.
 *
 * This is deliberately NOT an `AnalyticsContext`, and stays that way: it is published at `KellyChatGate`, which
 * sits above the account Outlet, so an AnalyticsContext here would nest `DashboardAnalyticsProvider` inside it
 * and every dashboard event would inherit Kelly's prefixes. The prefixes live on `KellyDockAnalyticsProvider`
 * instead, which wraps the dock alone — a sibling of the Outlet.
 */

import { createContext, useContext } from "react"
import type { TrackingProperties } from "connected-components/analytics/context"

/** Absent provider contributes nothing — a stable reference, so it can't churn a consumer's memo. */
const EMPTY_KELLY_SURFACE: TrackingProperties = {}

const KellySurfaceContext = createContext<TrackingProperties>(EMPTY_KELLY_SURFACE)

export const KellySurfaceProvider = KellySurfaceContext.Provider

export function useKellySurfaceProperties(): TrackingProperties {
  return useContext(KellySurfaceContext)
}
